import moment from "moment";
import { PRIMARY_COLOR, PRIMARY_TEXT_COLOR } from "../../color";
import CustomDataTable from "../../Components/CustomDataTable";
import { genareteColor } from "../../Helper/GenerateStatusColor";
import Notiflix from "notiflix";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import PostApiCall from "../../Api/Api";
import GetApiCall from "../../Api/GetApi";
import { useSelector } from "react-redux";
import { SomethingWrong } from "../../Helper/ErrorMessages";
import { Button } from "reactstrap";
import { delay } from "../../Helper/ToastDelay";



const RefereeList = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const columns = [
    {
      field: "fld_name",
      header: "Auditor Name",
      sortable: true,
      headerStyle: { width: "100px", minWidth: "100px", fontSize: "13px" },
      bodyStyle: { minWidth: "150px", fontSize: "13px", textTransform: "capitalize" },
    },
    {
      field: "fld_username",
      header: "Referred By",
      sortable: true,
      headerStyle: { width: "150px", minWidth: "150px", fontSize: "13px" },
      bodyStyle: { minWidth: "250px", fontSize: "13px", textTransform: "capitalize" },
    },
    {
      field: "fld_paymentstatus",
      header: "Audit Status",
      sortable: true,
      headerStyle: { width: "120px", minWidth: "120px", fontSize: "13px" },
      bodyStyle: { minWidth: "250px", fontSize: "13px" },
    },

    {
      field: "fld_onboardstatus",
      header: "Onboard Status",
      sortable: true,
      headerStyle: { width: "180px", minWidth: "180px", fontSize: "13px" },
      bodyStyle: { minWidth: "250px", fontSize: "13px" },
    },
  ];

  const [refereeData, setRefereeData] = useState([]);
  const [filterRefereeData, setFilterRefereeData] = useState([]);


  // const filterMethod = (search) => {
  //   console.log(search);
  //   const result = refereeData.filter((item) => {
  //     const searchMatches = Object.values(item).some((value) =>
  //       String(value).toLowerCase().includes(search.toLowerCase())
  //     );

  //     return searchMatches;
  //   });
  //   setFilterRefereeData(result);
  // };

  const GetRefereeList = async () => {
    Notiflix.Loading.standard();
    try {
      await GetApiCall.getRequest("GetRefereeList").then((resultdes) =>
        resultdes.json().then((obj) => {
          console.log("referee", obj);
          setRefereeData(obj?.data);
          setFilterRefereeData(obj?.data);
        })
      );
    } catch (error) {
      toast.error(SomethingWrong, {
        autoClose: delay,
        toastId: 1,
      });
    }
    Notiflix.Loading.remove();
  };
  const profile = JSON.parse(localStorage.getItem("user"));
  console.log("profile", profile);
  useEffect(() => {
    if (profile && !profile.fld_usertype.includes('Seeker', 'Auditor')) {
      GetRefereeList();
    }
  }, []);


  return (
    <div>
      <div className="d-flex justify-content-between align-items-center flex-wrap mt-4">
        <h5 style={{ color: PRIMARY_TEXT_COLOR }}>Refer User List</h5>
      </div>
      <div className="mt-2" style={{ minHeight: "400px" }}>
        <CustomDataTable
          data={filterRefereeData}
          columns={columns}
          compact={true} // Enables compact styling
        />
      </div>
    </div>
  );
};

export default RefereeList;
